import { observable, computed } from 'mobx'
import layer from 'layer-websdk'
import { Model } from 'libx'
import { SENDING, SENT, DELIVERED, READ } from 'consts/MessageReceiptState'
import moment from 'moment'
import map from 'lodash/map'

class Message extends Model {
  @observable id
  @observable text = ''
  @observable sender
  @observable sentAt = moment()
  @observable allRecipientStatuses = []
  @observable type = 'text'

  @computed get receiptState () {
    let receiptState = null
    if (this.hasRecipientStatus(layer.Constants.RECEIPT_STATE.PENDING)) {
      receiptState = SENDING
    }

    if (this.hasRecipientStatus(layer.Constants.RECEIPT_STATE.SENT)) {
      receiptState = SENT
    }

    if (this.hasRecipientStatus(layer.Constants.RECEIPT_STATE.DELIVERED)) {
      receiptState = DELIVERED
    }

    if (this.hasRecipientStatus(layer.Constants.RECEIPT_STATE.READ)) {
      receiptState = READ
    }

    return receiptState
  }

  @computed get isRead () {
    return this.myRecipientStatus.status === 'read'
  }

  @computed get recipientStatus () {
    return this.allRecipientStatuses.filter(x => x !== this.myRecipientStatus)
  }

  @computed get myRecipientStatus () {
    return this.allRecipientStatuses.find(x => x.recipient === this.rootStore.authStore.user)
  }

  hasRecipientStatus (status) {
    return this.recipientStatus.some(x => x.status === status)
  }

  parse (json, opts) {
    const createdHere = opts ? opts.createdHere : false
    const { id, parts, conversationId, sentAt, recipientStatus, sender } = json
    const part = parts[0]
    const data = {
      id,
      createdHere,
      conversationId,
      type: 'text',
      sentAt: moment(sentAt),
      allRecipientStatuses: this._mapRecipientStatus(recipientStatus),
      sender: this.rootStore.userStore.userByAuthId(sender.userId),
      text: part.body // lol sue me
    }

    if (part.mimeType === 'application/json') {
      const body = JSON.parse(part.body)
      data.type = body.type
      if (data.type === 'document') {
        data.text = ''
        // Odds are the one we have in memory (if we do) is more up-to-date.
        const doc = this.rootStore.documentStore.documents.get(body.data.Key)
        data.document = doc || this.rootStore.documentStore.documents.set(body.data)
      }
    }
    return data
  }

  _mapRecipientStatus (recipientStatus) {
    return map(recipientStatus, (value, key) => {
      const id = decodeURIComponent(key.replace('layer:///identities/', ''))
      return {
        status: value,
        recipient: this.rootStore.userStore.userByAuthId(id)
      }
    })
  }
}

export default Message



// WEBPACK FOOTER //
// ./src/client/domain/Message.js